export default [
  {
    name: '工具',
    path: '/tools',
    routes: [
      {
        name: '图片翻译',
        path: '/tools/image-translate',
        component: './tools/image-translate',
        meta: {
          hideNav: true,
          showWorkbench: false,
          hideBorder: true,
          menuIcon: 'zhinengfanyi',
          img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/AIgongjurukou-tupianfanyi@2x.png',
					subLabel: '一键译图，畅销全球',
        },
      },
      {
        name: '智能抠图',
        path: '/tools/image-cutout',
        component: './tools/image-cutout',
        meta: {
          hideNav: true,
          showWorkbench: false,
          hideBorder: true,
          menuIcon: 'Matting',
          img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/AIgongjurukou-zhinengkoutu@3x.png',
					subLabel: '发丝级抠图，细节尽显',
        },
      },
      {
        name: '智能换背景',
        path: '/tools/background-replacement',
        component: './tools/background-replacement',
        meta: {
          hideNav: true,
          showWorkbench: false,
          hideBorder: true,
          menuIcon: 'zhinengbeijing',
          img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/AIgongjurukou-zhinenghuanbeijing@3x.png',
					subLabel: '背景魔法，焕然一新',
        },
      },
      {
        name: '智能扩图',
        path: '/tools/image-expand',
        component: './tools/imgExpand',
        meta: {
          hideNav: true,
          showWorkbench: false,
          hideBorder: true,
          menuIcon: 'zhinengkuotu',
          img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/AIgongjurukou-zhinengkuotu@3x.png',
					subLabel: '智能补全，场景延伸',
        },
      },
      {
        name: '智能超清',
        path: '/tools/image-quality',
        component: './tools/image-quality',
        meta: {
          hideNav: true,
          showWorkbench: false,
          hideBorder: true,
          menuIcon: 'zhinenggaoqing',
          img: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/AIgongjurukou-zhinengchaoqing@3x.png',
					subLabel: '超清还原，质感升级',
        },
      },
    ],
  },
]
